import actions from '../../actions-list';

export const setRgaResultFlag = isEmptyRgaSearchResult => ({
    isEmptyRgaSearchResult,
    type: actions.UPDATE_RGA_SEARCH_RESULTS_FLAG
});



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/action-creators/rga-result-list-flag.js